module.exports = __webpack_public_path__ + "img/bg-img-white1.ffde198e.png";